import { getDataBase } from "../db";

export default class GeneracionLecturaDAL {



    async GetIDBy(GeneracionFactura, Cliente, DataBaseAlias){
        try {
            
            const db = await getDataBase(); // Conectar a IndexedDB
            const tx = db.transaction('GENERACIONLECTURA', 'readonly');
            const store = tx.objectStore('GENERACIONLECTURA');
            const laClientes = await store.getAll(Number(Cliente));
            const laResult = [];
            laClientes.forEach( (loCliente) =>{
                if (loCliente.GeneracionFactura == GeneracionFactura) {
                    laResult.push(loCliente); 
                }
            });

            await tx.done;
            return laResult;

        } catch (error) {
            console.error(error);
            return [];
        }
    }

    static getByGenFactura = async (tnGeneracionFactura) => {
        try {
            const db = await getDataBase();
            const tx = db.transaction('GENERACIONLECTURA', 'readonly');
            const store = tx.objectStore('GENERACIONLECTURA');
            const index = store.index('GeneracionFactura');
            const laClientes = await index.getAll(Number(tnGeneracionFactura));

            const filtroClientes = laClientes.filter(loCliente => loCliente.EstadoLectura == 0);
            await tx.done;
            return filtroClientes;
        } catch (error) {
            console.error('Error al buscar clientes por GeneracionFactura:', error);
            return [];
        }
    } 


    async GetRecDt2(tcGeneracionLectura, tcCliente, DataBaseAlias){
        try {
            const db = await getDataBase(); // Conectar a IndexedDB
            const tx = db.transaction('GENERACIONLECTURA', 'readonly');
            const store = tx.objectStore('GENERACIONLECTURA');
            const laClientes = await store.getAll(Number(tcCliente));
            const laResult = [];
            laClientes.forEach((loCliente)=>{
                if (loCliente.GeneracionFactura == tcGeneracionLectura) {
                    laResult.push(loCliente); 
                }
            });

            await tx.done;
            return laResult;

        } catch (error) {
            console.error(error);
            
            return [];
        }
    }


    async actualizarLecturaDAL(TipoReglaAplicar, gnGeneracionFactura, gnCliente, gnLecturaActual, gnConsumoActual, gnMedidorAnormalidad, DataBaseAlias, validar, ConsumoFacturado) {
        // Asegúrate de que los valores sean válidos
        gnLecturaActual = gnLecturaActual == null ? 0 : gnLecturaActual;
        gnConsumoActual = gnConsumoActual < 0 ? 0 : gnConsumoActual;
        const lnConsumoFacturado = ConsumoFacturado < 0 ? 0 : ConsumoFacturado;
   
        try {
            const db = await getDataBase(); // Conectar a IndexedDB
            const tx = db.transaction('GENERACIONLECTURA', 'readwrite');
            const store = tx.objectStore('GENERACIONLECTURA');
            
            let loDato = null;
            //buscar por cliente 
            const laClientes = await store.getAll(Number(gnCliente));
            laClientes.forEach(async loCliente => {
                if(loCliente.GeneracionFactura == gnGeneracionFactura){
                    loDato = loCliente;
                }
            });

             if (!loDato) {
                console.error("Registro no encontrado");
                return null;
            }

            // Actualizar los valores según el tipo de regla
            loDato.LecturaActual = gnLecturaActual;
            loDato.Consumo = gnConsumoActual;
            loDato.MedidorAnormalidad = gnMedidorAnormalidad;
            loDato.ConsumoFacturado = lnConsumoFacturado;
            await store.put(loDato); // Actualizar el registro
            // Completar la transacción
            //datos se deben guardar


            await tx.done;
            return loDato;
        } catch (error) {
            console.error("Error al actualizar lectura en DAL", error);
            return null;
        }
    }

    
    async ActualizarLecturaSinMedidorDAL(gnGeneracionFactura, gnCliente, gnLecturaActual, gnConsumoActual, gnMedidorAnormalidad, DataBaseAlias) {
        try {
            // Abrir la base de datos y crear una transacción en modo 'readwrite'
            const db = await getDataBase();
            const tx = db.transaction('GENERACIONLECTURA', 'readwrite');
            const store = tx.objectStore('GENERACIONLECTURA');
            const laClientes = await store.getAll(Number(gnCliente));
           
            for (const loCliente of laClientes) {
                if (loCliente.GeneracionFactura == gnGeneracionFactura) {

                    //  Actualizar los valores
                     loCliente.LecturaActual = gnLecturaActual;
                     loCliente.Consumo = gnConsumoActual;
                     loCliente.MedidorAnormalidad = gnMedidorAnormalidad;
                     loCliente.ConsumoFacturado =  gnConsumoActual;
     
                     // Guardar los cambios en IndexedDB
                     store.put(loCliente);
                }
            };
    
            await tx.done; // Esperar a que la transacción termine
    
            console.log('Lecturas actualizadas correctamente');
            return true; // Retornar verdadero para indicar éxito
        } catch (error) {
            console.error('Error actualizando lecturas en IndexedDB:', error);
            return false; // Retornar falso en caso de error
        }
    }
    



    // public function Update($laDatosActualizar){
    //     $loGeneracionLectura = GeneracionLectura::on($laDatosActualizar['DataBaseAlias'])
    //         ->where('GeneracionFactura', '=', $laDatosActualizar['GeneracionFactura'])
    //         ->where('Cliente', '=', $laDatosActualizar['Cliente'])
    //         ->update(["ConsumoFacturado" => $laDatosActualizar['ConsumoFacturado']]);

    //     return $loGeneracionLectura;
    // }
    async Update(laDatosActualizar){
        try {
            const db = await getDataBase();
             const tx = db.transaction('GENERACIONLECTURA', 'readwrite');
             const store = tx.objectStore('GENERACIONLECTURA');
            //  const index = store.index('GeneracionFactura');
            //  const laGeneracionLecturas = await index.getAll(Number(laDatosActualizar.GeneracionFactura));
            const laClientes = await store.getAll(Number(laDatosActualizar.Cliente));

            for (const loCliente of laClientes) {
                if(loCliente.GeneracionFactura == laDatosActualizar.GeneracionFactura){
                    loCliente.ConsumoFacturado = laDatosActualizar.ConsumoFacturado;
                    await store.put(loCliente);
                }
            }

             await tx.done;
             return laClientes;
           } catch (error) {
             console.error('Error Update de :', error);
             return [];
           }
    }

    //actuializar estado de cliente en 1 
    static actualizarEstadoLectura = async (tnCliente) => {
    try {
      const db = await getDataBase();
  
      const tx1 = db.transaction('GENERACIONLECTURA', 'readwrite');
      const store1 = tx1.objectStore('GENERACIONLECTURA');
      const loCliente = await store1.get(Number(tnCliente));
  
      if (loCliente) {
        loCliente.EstadoLectura = 1;
        await store1.put(loCliente);
        await tx1.done;
      } else {
        console.warn('Cliente no encontrado:', tnCliente);
      }
    } catch (error) {
      console.error('Error al actualizar estado de cliente:', error);
    }
  };

}